import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/proceso/getProceso.php';

export default function getProceso({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}